export const TEMPLATE_UPLOAD_CAMPAIGN = "TEMPLATE_UPLOAD_CAMPAIGN.xlsx";
export const TEMPLATE_UPLOAD_CTKT = "TEMPLATE_UPLOAD_CTKT.xlsx";
